import type { Theme } from '../types';

// just for test mocking
export const getHostname = () => window.location.hostname;

export const getWindow = (): Window & {
  __hubspotTheme?: Record<string, Theme>;
} => window;
